// extracted by css-extract-rspack-plugin
export default {"cls1":"Link-cls1_h6p","cls2":"Link-cls2_0El Link-cls1_h6p"};